var Tickets = $.extend(false, BaseModule ,{

    api_route : 'tickets',

    data : {
    	module          : 'tickets',
    	page            : 1,
    	limit           : 20,
        view            : 'list',
        order_by        : 'id:desc',
        pagination      : true
    },

    keydownTimer:null,


    before_save:function(){
        var module_name = this.data.module;
        Builder.set_target($('form[name="'+module_name+'_form"]')).commit();
    },

    after_load_entry:function(){
        "use strict";
        var module_name = this.data.module;
        this.save();
        Builder.set_target($('form[name="'+module_name+'_form"]')).setup();
    },

    init:function(){
        var module_name = this.data.module,module = this;
    }
});

$(document).ready(function(){
    "use strict";
    Tickets.init();
});
